import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import api from "@/api";
import { Gauge, BookOpen, Image, Languages, ArrowRight, KeyRound, CheckCircle2, AlertCircle } from "lucide-react";

const TOOLS = [
  {
    slug: "idea-evaluator",
    title: "Viral Idea Evaluator",
    tagline: "$100K Investment Test",
    desc: "Strategic brutal evaluation of your book idea across viral potential, pain points, emotional triggers, and positioning.",
    icon: <Gauge size={22} />,
    cta: "Evaluate",
  },
  {
    slug: "book-studio",
    title: "Viral Book Studio",
    tagline: "From concept to launch",
    desc: "End-to-end book creation — concept, titles, structure, chapters, covers and launch pipeline. Pure craft.",
    icon: <BookOpen size={22} />,
    cta: "Start Writing",
  },
  {
    slug: "cover-studio",
    title: "Viral Book Cover Studio",
    tagline: "Scroll-stopping covers",
    desc: "Generate high-conversion cover concepts tailored to your book's promise, audience and genre.",
    icon: <Image size={22} />,
    cta: "Design Cover",
  },
  {
    slug: "pubglot",
    title: "PubGlot",
    tagline: "Professional translation",
    desc: "Translate .docx, .pdf and .epub documents into 15+ languages while preserving original formatting.",
    icon: <Languages size={22} />,
    cta: "Translate",
  },
];

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <Shell>
      <h1 className="vbs-page-h">
        Welcome back, <em>{(user?.full_name || user?.email || "").split(" ")[0] || "creator"}</em>.
      </h1>
      <p className="vbs-page-p">
        Four tools built for authors who want to go viral. Evaluate sharp ideas, write
        with clarity, design covers that stop scrolls, and translate for a global audience.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 18,
        }}
      >
        {TOOLS.map((t) => (
          <Link
            key={t.slug}
            to={`/tools/${t.slug}`}
            className="vbs-tool-card"
            data-testid={`tool-card-${t.slug}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div className="vbs-tool-ico">{t.icon}</div>
            <div>
              <div
                style={{
                  fontFamily: "var(--font-mono)",
                  fontSize: 10,
                  letterSpacing: 1.5,
                  color: "var(--gold-dim)",
                  textTransform: "uppercase",
                  marginBottom: 4,
                }}
              >
                {t.tagline}
              </div>
              <div className="vbs-tool-title">{t.title}</div>
              <div className="vbs-tool-sub" style={{ marginTop: 8 }}>
                {t.desc}
              </div>
            </div>
            <div className="vbs-tool-cta">
              {t.cta} <ArrowRight size={14} />
            </div>
          </Link>
        ))}
      </div>
    </Shell>
  );
}
